import { Text, theme, Stack } from "@tonic-ui/react";
import Trend from "@/assets/img/TrendAI-Logo-Icon-Full-Color-RGB.svg";
import { FormattedMessage } from "react-intl";

export default function Banner({ title }: { title?: string }) {
    const isAirGap = process.env.REACT_APP_AIR_GAP === "Tcp";

    return (
        <header>
            <Stack
                gap="3x"
                direction="row"
                px="6x"
                h={64}
                py={theme.sizes["7h"]}
                backgroundColor={theme.colors["gray:90"]}
            >
                <img src={Trend} alt="TrendAI icon" width={32} height={32} />
                <Text size="2xl" color="white:primary" fontWeight="light">
                    {isAirGap ? (
                        <FormattedMessage defaultMessage="TrendAI Vision One™ for Sovereign and Private Cloud" />
                    ) : title ? (
                        title
                    ) : (
                        <FormattedMessage defaultMessage="TrendAI Vision One™ | License Activation Service" />
                    )}
                </Text>
            </Stack>
        </header>
    );
}
